var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as d3 from "d3";
import ViewState from "../viewState";
import GeneralUtil from "../../utils/generalUtil";
import AppSettings from "../appSettings";
import LookAndStyle from "../../styling/lookAndStyle";
//import MpointHoverCircle from "./mpointHoverCircle";
import { MapAppMode } from "../../models/metMap/mapAppMode";
export default class Markers {
    constructor(mpointMap) {
        try {
            this._svg = mpointMap.overlay;
            this._defs = this._svg
                .append("defs");
            this._mpointMap = mpointMap;
            const hullGroup = this._svg.append("g")
                .attr("id", "hullGroup"); //hulls underst i lagret
            hullGroup.append("g")
                .attr("id", "hullHeadersGroup");
            this._svg.append("g")
                .attr("id", "glowGroup");
            this._svg.append("g")
                .attr("id", "mpointGroup");
            this._svg.append("g")
                .attr("id", "hoverGroup");
            const markers = this._svg.select("#mpointGroup")
                .selectAll(".mpointMarker")
                .data(ViewState.mPointMarkers);
            if (AppSettings.AppMode === MapAppMode.PQWEB) {
                Markers.markerSelection = markers.enter().append("g")
                    .attr("class", "mpointMarker metrum-clickable")
                    .attr("id", d => "mpointMarker" + d.mpointId);
                ViewState.blazorIcons = new Map();
                this.updateBlazorIcons();
                Markers.markerSelection
                    .on("mouseover", (mpoint) => {
                    ViewState.dotNetRef.invokeMethodAsync('OnJsHoverMPointMarker', mpoint.mpointId);
                })
                    .on("mouseout", () => {
                    ViewState.dotNetRef.invokeMethodAsync('OnJsUnHoverMPointMarker', null);
                })
                    .on("click", (mpoint) => {
                    d3.event.stopPropagation();
                    ViewState.dotNetRef.invokeMethodAsync('OnJsClickMPointMarker', mpoint.mpointId);
                });
            }
            else {
                //Markers.markerSelection = markers.enter().append<SVGElement>("circle")
                //    .attr("class", "mpointMarker mpointCircle")
                //    .attr("r", 5)
                //    .style("fill", (d, i) => "url(#grad" + i + ")");
                //Markers.backGlowSelection = this._svg.select<SVGElement>("#glowGroup")
                //    .selectAll<SVGElement, {}>(".glowCircle")
                //    .data(ViewState.mPointMarkers)
                //    .enter().append<SVGElement>("circle")
                //    .attr("class", "glowCircle");
                //this.setLabels(ViewState.mPointMarkers);
                //this.initMarkerGlow();
                //this.initMarkerColors();
                //if (AppSettings.AppMode === MapAppMode.PQ4CAST) {
                //    this._hoverCircle = new HoverCircle(mpointMap);
                //    Markers.markerSelection
                //        .on("mouseover", (mpoint) => {
                //            MpointHoverCircle.hover(mpoint._mpoint);
                //        })
                //        .on("mouseout", () => {
                //            MpointHoverCircle.unHover();
                //        })
                //        .on("click", (mpoint) => {
                //            d3.event.stopPropagation();
                //            MpointHoverCircle.lockUnlockMenu(mpoint._mpoint);
                //        });
                //}
            }
        }
        catch (error) {
            GeneralUtil.handleError("Error in Markers constructor", error);
        }
    }
    updateBlazorIcons() {
        ViewState.mPointMarkers.forEach((mpMarker) => __awaiter(this, void 0, void 0, function* () {
            try {
                let blazorIcon = ViewState.blazorIcons.get(mpMarker.mpointId);
                if (blazorIcon) {
                    yield blazorIcon.dispose();
                }
                yield this.initBlazorIcon(mpMarker);
            }
            catch (error) {
                //dölj felmeddelanden när Blazor klagar på att komponenter redan finns vid initiering 
            }
        }));
    }
    initBlazorIcon(mpMarker) {
        return __awaiter(this, void 0, void 0, function* () {
            //@ts-ignore
            const blazorIcon = yield Blazor.rootComponents.add(document.getElementById("mpointMarker" + mpMarker.mpointId), 'mPointMarkerIcon', { type: mpMarker._mpoint.stationType, status: mpMarker._mpoint.pqStatus, notificationStatus: mpMarker._mpoint.notificationStatus, selectMode: mpMarker.selectMode });
            ViewState.blazorIcons.set(mpMarker.mpointId, blazorIcon);
        });
    }
    initMarkerColors() {
        const gradientSelection = this._defs
            .selectAll("radialGradient")
            .data(ViewState.mPointMarkers)
            .enter().append("radialGradient")
            .attr("id", function (d, i) { return "grad" + i; });
        gradientSelection
            .append("stop")
            .attr("offset", "0%")
            .attr("class", "offset0")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .6, .5).toString());
        gradientSelection
            .append("stop")
            .attr("offset", "100%")
            .attr("class", "offset100")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .5, .3).toString());
    }
    initMarkerGlow() {
        const glowFilter = this._defs
            .selectAll("filter")
            .data(ViewState.mPointMarkers)
            .enter().append("filter")
            .attr("id", function (d, i) { return "glow" + i; })
            .append("feGaussianBlur")
            .attr("stdDeviation", 4)
            .attr("result", "coloredBlur");
        const feMerge = glowFilter.append("feMerge");
        feMerge.append("feMergeNode")
            .attr("in", "coloredBlur");
        feMerge.append("feMergeNode")
            .attr("in", "SourceGraphic");
        Markers.backGlowSelection
            .style("opacity", 0.5)
            .style("filter", function (d, i) { return "url(#glow" + i + ")"; });
    }
    updateData(mPointIds = []) {
        this.blinkMPoints(mPointIds);
        //if (AppSettings.AppMode === MapAppMode.PQ4CAST) {
        //    this._hoverCircle.updateData(mPointIds);
        //}
    }
    blinkMPoints(mPointIds) {
        const durUp = 1000;
        const durDown = 2000;
        const glowFactor = AppSettings.MPOINT_GLOW_UPDATE;
        const tGrad0 = this._defs
            .selectAll("radialGradient")
            .filter(mp => mPointIds.length == 0 || mPointIds.some(id => mp._mpoint.id === id))
            .transition()
            .duration(durUp);
        const tGlow0 = Markers.backGlowSelection
            .filter(mp => mPointIds.length == 0 || mPointIds.some(id => mp._mpoint.id === id))
            .transition()
            .duration(durUp);
        tGrad0.select(".offset0")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .7, .6).toString());
        tGrad0.select(".offset100")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .5, .5).toString());
        tGlow0
            .attr("r", mpoint => mpoint.glowSize * glowFactor)
            .style("fill", mpoint => d3.hsl(mpoint.color.h, .7, .7).toString());
        const tGrad1 = tGrad0.transition().duration(durDown);
        const tGlow1 = tGlow0.transition().duration(durDown);
        tGrad1.select(".offset0")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .5, .5).toString());
        tGrad1.select(".offset100")
            .attr("stop-color", (mpoint) => d3.hsl(mpoint.color.h, .4, .3).toString());
        tGlow1
            .attr("r", mpoint => mpoint.glowSize)
            .style("fill", mpoint => d3.hsl(mpoint.color.h, .4, .5).toString());
    }
    updateCoords() {
        try {
            if (Markers.markerSelection)
                Markers.markerSelection
                    .attr("transform", this.translateToMPointMarkerProps.bind(this));
            if (Markers.backGlowSelection)
                Markers.backGlowSelection
                    .attr("transform", this.translateToMPointMarkerProps.bind(this));
            //if (HoverCircle?.gHoverSelection)
            //    HoverCircle.gHoverSelection
            //        .attr("transform", this.translateToMPointMarkerProps.bind(this));
            if (Markers.labelSelection)
                Markers.labelSelection
                    // @ts-ignore
                    .attr("transform", this.translateToMPointMarkerProps.bind(this));
        }
        catch (error) {
            throw new Error("Failed to update mpoint markers" + "\r\n" + error);
        }
    }
    setLabels(markers) {
        Markers.labelSelection = this._svg.select("g").selectAll(".place-label")
            .data(markers)
            .enter().append("text")
            .attr("class", "place-label")
            .text(function (d) { return d.labelText; })
            .attr("dy", function (d) { return LookAndStyle.RADIUS_HOVER_CIRCLE + 26; })
            .style("opacity", 0)
            .attr("text-anchor", "middle");
    }
    translateToMPointMarkerProps(mpoint) {
        return `translate (${mpoint.x}, ${mpoint.y})`;
    }
}
